import React from "react"
import * as faqStyles from "./faq.module.scss"

const Faq = () => {
  return (
    <section className={faqStyles.wrapper} id="faq">
      <h2 className={faqStyles.header}>Commonly Asked Questions</h2>
      <ul className={faqStyles.questionsWrapper} role="group">
        <li className={faqStyles.singleQuestion} aria-label="FAQ">
          <h3 className={faqStyles.question}>Do I Need an Appointment?</h3>
          <p className={faqStyles.answer}>
            Modern Eye is open for browsing and trying on glasses without an
            appointment. However, appointments are required for all eye
            examinations. If you'd like to schedule an eye exam, please call
            ahead to ensure availability.
          </p>
        </li>
        <li className={faqStyles.singleQuestion} aria-label="FAQ">
          <h3 className={faqStyles.question}>Do You Take Insurance?</h3>
          <p className={faqStyles.answer}>
            Most major medical insurance is accepted if you have a medical
            complaint. Separate vision plans cover or partially cover eye exams
            and often eyeglasses and/or contact lenses. Currently, Modern Eye is
            a provider for the following vision plans: Vision Service Plan (VSP)
            and Vision Benefits of America (VBA).
          </p>
        </li>
      </ul>
    </section>
  )
}

export default Faq
